import React from 'react';
import { CheatSheetBoxProps } from '../../Dog';
import './CheatSheetBox.module.scss';

export default function CheatSheetBox(props: CheatSheetBoxProps) {
    const slug = props.text.split(' ').join('-').toLowerCase();

    return (
        <div styleName={`box ${slug} ${props.back === true ? 'back' : ''}`}>
            <div styleName="top">
                <h6>{props.text}</h6>
            </div>
            <div styleName="bottom">{props.children}</div>
        </div>
    );
}
